module.exports = __webpack_public_path__ + "static/img/icon-safe1.9fb8a76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-safe1.png
// module id = qqTH
// module chunks = 21